import heroHome from './components/sliders/hero_home';

heroHome.init();
